import { render } from "./BarChartDemo.vue?vue&type=template&id=005c44b2&scoped=true"
import script from "./BarChartDemo.vue?vue&type=script&lang=ts"
export * from "./BarChartDemo.vue?vue&type=script&lang=ts"

import "./BarChartDemo.vue?vue&type=style&index=0&id=005c44b2&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-005c44b2"

export default script